module.exports = __webpack_public_path__ + "img/ky.f1dc04c8.png";